
































































































import { Vue, Component } from "vue-property-decorator"
import SInfoBox from "@/components/SInfoBox"
import SStatusBox from "@/components/SStatusBox"
import SCustomer from "@/components/SCustomer"
import { Market } from "@/models"
import {
    GET_MARKET_LIST,
    GET_DASHBOARD_TOTAL_VENUE,
    GET_DASHBOARD_TOTAL_BOX,
    GET_DASHBOARD_TOTAL_ONLINE_BOX,
    GET_DASHBOARD_TOTAL_OFFLINE_BOX,
    GET_DASHBOARD_TOTAL_UPDATE_REQUIRED_BOX,
    GET_MARKET_TOTAL_BOX_FN,
    GET_MARKET_TOTAL_ONLINE_BOX_FN,
    GET_MARKET_TOTAL_OFFLINE_BOX_FN,
    GET_MARKET_TOTAL_UPDATE_REQUIRED_BOX_FN,
} from "@/store/types/getters"
import {
    UPDATE_SELECTED_MARKET,
    CLEAR_SELECTED_MARKET,
} from "@/store/types/mutations"
import { fetchMarketList } from "@/store/types/actions"
import SCustomerForm from "@/components/SCustomerForm"
import SCustomerSearchForm from "@/components/SCustomerSearchForm"
import { MarketModule } from "@/consts"
import { Getter } from "vuex-class"

@Component({
    components: {
        SInfoBox,
        SStatusBox,
        SCustomer,
        SCustomerForm,
        SCustomerSearchForm,
    },
})
export default class CustomerList extends Vue {
    @Getter(GET_DASHBOARD_TOTAL_VENUE)
    dashboardTotalVenue!: number
    @Getter(GET_DASHBOARD_TOTAL_BOX) dashboardTotalBox!: number
    @Getter(GET_DASHBOARD_TOTAL_ONLINE_BOX)
    dashboardTotalOnlineBox!: number
    @Getter(GET_DASHBOARD_TOTAL_OFFLINE_BOX)
    dashboardTotalOfflineBox!: number
    @Getter(GET_DASHBOARD_TOTAL_UPDATE_REQUIRED_BOX)
    dashboardTotalUpdateRequiredBox!: number

    @Getter(GET_MARKET_TOTAL_BOX_FN)
    marketTotalBoxFn!: (marketId: string) => number
    @Getter(GET_MARKET_TOTAL_ONLINE_BOX_FN)
    marketTotalOnlineBoxFn!: (marketId: string) => number
    @Getter(GET_MARKET_TOTAL_OFFLINE_BOX_FN)
    marketTotalOfflineBoxFn!: (marketId: string) => number
    @Getter(GET_MARKET_TOTAL_UPDATE_REQUIRED_BOX_FN)
    marketTotalUpdateRequiredBoxFn!: (marketId: string) => number

    @MarketModule.Getter(GET_MARKET_LIST) marketList!: Market[]
    @MarketModule.Mutation(UPDATE_SELECTED_MARKET) updateSelectedMarket!: (
        paylaod: Market
    ) => void
    @MarketModule.Mutation(CLEAR_SELECTED_MARKET)
    clearSelectedMarket!: () => void
    @MarketModule.Action(fetchMarketList) fetchMarketList!: () => void

    private onBack() {
        this.clearSelectedMarket()
        this.$router.push("/dashboard")
    }

    private onSearch() {
        const options = {
            name: "SCustomerSearchForm",
            height: "auto",
            draggable: true,
        }

        this.$modal.show(SCustomerSearchForm, undefined, options)
    }

    private onClick(payload: Market) {
        this.updateSelectedMarket(payload)
        this.$router.push(`/customers/${payload.id}/dashboard`)
    }

    private onAdd() {
        const options = {
            name: "SCustomerForm",
            height: "auto",
            draggable: true,
        }

        this.$modal.show(SCustomerForm, undefined, options)
    }

    public mounted() {
        this.fetchMarketList()
    }

    public activated() {
        this.fetchMarketList()
    }
}
